import React from 'react';

export const Line = props => {
	return <div className="horizontal-line" />;
};


// WEBPACK FOOTER //
// src/atoms/lib/Line.js